/*
 * Focus Trap helpers
 */

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  first.focus();
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, wait) {
  let t = false;
  return (...args) => {
    if (!t) {
      fn.apply(this, args)
      t = true;
      setTimeout(() => t = false, wait)
    }
  }
}

/*
 * Woolman Common JS
 */

// Initialize window.Woolman object
if (typeof window.Woolman == 'undefined') {
  window.Woolman = {};
}
Woolman.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

// -------
// Load components / libraries
Woolman.init = function () {
  Woolman.ModalsAndDrawers.init();
  Woolman.Header.init();
  Woolman.DetailsAccordions.init();

   // Attach theme editor listeners
   if (!Shopify || !Shopify.designMode) return;

  let lastSelection = {
    sectionId: undefined,
    blockId: undefined
  };

  // Load is called when something is changed within section settings
  document.addEventListener('shopify:section:load', (evt) => {
    const sectionId = 'shopify-section-' + evt.detail.sectionId
    if (sectionId === Woolman.Header.cache.section.id) {
      Woolman.ModalsAndDrawers.init();
      Woolman.Header.init();
    }

    if (document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`)) {
      Woolman.ModalsAndDrawers.showModalOrDrawer(document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`).id);
    }

    console.log('shopify:section:load sectionId', evt.detail.sectionId)
    console.log('lastSelection', lastSelection)
  })

  document.addEventListener('shopify:block:select', (evt) => {
    const sectionId = 'shopify-section-' + evt.detail.sectionId
    const blocks = document.getElementById(sectionId).querySelectorAll('[data-shopify-editor-block]')
    const selectedBlock = [...blocks].find(x => JSON.parse(x.dataset.shopifyEditorBlock).id === evt.detail.blockId);
    if (sectionId === Woolman.Header.cache.section.id) {
      if (selectedBlock) {
        // Make sure menu is open
        Woolman.Header.cache.openButton.click();

        // Select menu item
        const accordion = selectedBlock.closest('[data-accordion-item]').querySelector('input');
        const label = selectedBlock.closest('[data-accordion-item]').querySelector('label');
        if (!accordion.checked) label.click();
      }
    } else if (sectionId.includes('modal') && document.getElementById(sectionId).querySelector('[data-modal]')) {
      if (selectedBlock) {
        Woolman.ModalsAndDrawers.showModalOrDrawer(document.getElementById(sectionId).querySelector('[data-modal]').id);
      }
    }

    lastSelection.sectionId = evt.detail.sectionId;
    lastSelection.blockId = evt.detail.blockId;
    console.log('shopify:block:select', evt.detail.sectionId, evt.detail.blockId)
    console.log('lastSelection', lastSelection)
  })

  document.addEventListener('shopify:section:unload', (evt) => {
    console.log('shopify:section:unload sectionId', evt.detail.sectionId)
  })

  document.addEventListener('shopify:section:select', (evt) => {
    console.log('shopify:section:select', evt.detail.sectionId)
    lastSelection = {
      sectionId: evt.detail.sectionId,
      blockId: evt.detail.blockId
    }

    if (evt.detail.sectionId.includes('modal') && document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`)) {
      Woolman.ModalsAndDrawers.showModalOrDrawer(document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`).id);
    }

    console.log('lastSelection', lastSelection)
  })

  document.addEventListener('shopify:section:deselect', (evt) => {
    console.log('shopify:section:deselect', evt.detail.sectionId)
    lastSelection = {
      sectionId: undefined,
      blockId: undefined
    }

    if (evt.detail.sectionId.includes('modal') && document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`)) {
      Woolman.ModalsAndDrawers.closeModalOrDrawer(document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`).id);
    }

    console.log('lastSelection', lastSelection)
  })
};

// -------
// Woolman Common JS - Utility library
Woolman.Utils = {
  debugMode: true,
  /**
   * Returns the visible height (in px) of the Essential announcement bar ONLY when it is
   * actually occupying the top edge of the viewport (i.e. not scrolled away).
   *
   * This theme uses a non-sticky announcement bar injected by an app inside
   * `.essential_annoucement_bar_wrapper` (note the spelling). When scrolled away,
   * the element still has an `offsetHeight`, so we must use viewport geometry instead.
   */
  getAnnouncementOffset: (selector = '.essential_annoucement_bar_wrapper') => {
    const el = document.querySelector(selector);
    if (!el) return 0;

    const rect = el.getBoundingClientRect();

    // Fully scrolled out of view above the viewport
    if (rect.bottom <= 0) return 0;

    // If the bar is significantly below the top edge (e.g. pushed down), don't offset drawers
    // Use a small threshold (2px) to account for rounding/subpixel rendering after scrolling
    if (rect.top > 2) return 0;

    // Bar is at or near the top edge - return the visible height
    // Use rect.bottom if it's less than the element's height (partially scrolled)
    // Otherwise use the full height
    return Math.max(0, Math.round(Math.min(rect.bottom, rect.height)));
  },
  prepareQueryParams: () => {
    Shopify.queryParams = Shopify.queryParams || {};

    // Preserve existing query parameters
    if (location.search.length) {
      const params = location.search.substr(1).split('&');
      for (let i = 0; i < params.length; i++) {
        const keyValue = params[i].split('=');
        // Spaces are reverted back after the decode, since in component-facets.js we'll use URLSearchParams() method and we don't want to double decode the spaces
        if (keyValue.length) {
          Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]).replaceAll('+', ' ');
        }
      }
    }

    return Shopify.queryParams;
  },
  formatMoney(cents, format, options = {}) {
    const { convertCurrency = true } = options;
    const default_money_format = theme.settings.moneyFormat || '€{{amount}}';
    if (typeof cents == 'string') {
      cents = cents.replace('.', '');
    }
    if (convertCurrency && window?.Shopify?.currency?.rate) {
      cents = cents * parseFloat(window.Shopify.currency.rate || 1.0);
    }

    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || default_money_format;

    function defaultOption(opt, def) {
      return typeof opt == 'undefined' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? decimal + parts[1] : '';

      if (cents === decimal + '00') {
        cents = '';
      }

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  },
};

// -------
// Woolman Common JS - Header component
Woolman.Header = {
  selectors: {
    header: 'MainHeader',
    cartBlip: '.cart-blip'
  },
  cache: {
    header: undefined,
    cartBlip: undefined,
    section: undefined,
    openButton: undefined
  },

  init: function () {
    this.cache.header = document.getElementById(this.selectors.header);
    this.cache.cartBlip = this.cache.header.querySelector(this.selectors.cartBlip);
    this.cache.section = this.cache.header.closest('.shopify-section');
    this.cache.openButton = this.cache.header.querySelector('[href="#drawer-menu"]')

    // Update cart blip when product is added to cart.
    document.addEventListener('ajaxProduct:added', this.updateCartBlip.bind(this))
    document.addEventListener('cart:update', this.updateCartBlip.bind(this));

    if (this.cache.header.dataset.stickyBehavior === 'none') return;
    this.initStickyBehavior(this.cache.header.dataset.stickyBehavior)
  },

  initStickyBehavior(behaviorType) {
    const stickyConfig = {
      headerHeight: this.cache.header.clientHeight,
      behavior: behaviorType
    }

    document.documentElement.classList.add('sticky-header-initialized', `sticky-header-${behaviorType}`);
    document.documentElement.style.setProperty('--sticky-header-margin-top', `${stickyConfig.headerHeight}px`);

    if (behaviorType === 'scroll' || behaviorType === 'fixed') {
      // Show on scroll fixed header
      let prevScroll = window.scrollY || document.documentElement.scrollTop;
      let curScroll;
      let direction = 0;
      let prevDirection = 0;

      /*
      ** Find the direction of scroll
      ** 0 - initial, 1 - up, 2 - down
      */

      const toggleStickyHeader = (direction, curScroll) => {
        if ((direction === 1) || curScroll < stickyConfig.headerHeight) {
          document.documentElement.classList.remove('sticky-header-hide')
        } else if (direction === 2 && curScroll > stickyConfig.headerHeight) {
          document.documentElement.classList.add('sticky-header-hide')
        }

        prevDirection = direction;
      }

      window.addEventListener('scroll', throttle(() => {
        curScroll = window.scrollY || document.documentElement.scrollTop;

        if (curScroll >= 300) {
          document.documentElement.classList.add('sticky-header-show')
        } else {
          document.documentElement.classList.remove('sticky-header-show');
        }

        if (curScroll > prevScroll) {
          direction = 2; // user scrolling down
        } else {
          direction = 1; // user scrolling up
        }

        if (direction !== prevDirection && behaviorType === 'scroll') {
          toggleStickyHeader(direction, curScroll)
        }

        prevScroll = curScroll
      }, 50))

      setInterval(() => {
        if (direction === 2 && behaviorType === 'scroll' && curScroll >= 900) {
          toggleStickyHeader(direction, curScroll);
        }
        if (window.scrollY === 0) {
          document.documentElement.classList.remove('sticky-header-show', 'sticky-header-hide');
        }
      }, 200)
    }
  },

  async updateCartBlip(e) {
    const cart = e.detail && e.detail.cart && e.detail.cart.item_count || await (async function () {
      const res = await fetch('/cart.json');
      const cart = await res.json();
      return cart;
    })();

    this.cache.cartBlip.textContent = cart.item_count || 0;
    if (cart && cart.item_count == 0) {
      this.cache.cartBlip.setAttribute('hidden', true);
      this.cache.cartBlip.closest('.header-item__link').classList.remove('has-blip-visible');
    } else {
      this.cache.cartBlip.removeAttribute('hidden')
      this.cache.cartBlip.closest('.header-item__link').classList.add('has-blip-visible');
    }

    // Update notification cart amount at the same time (if present)
    const total_in_notification = document.querySelector('#cart-notification-link .cart-total');
    if (total_in_notification) {
      total_in_notification.textContent = cart.item_count;
    }
  }
};

// -------
// Woolman Common JS - Modals & drawers library
Woolman.ModalsAndDrawers = {
  settings: {
    selectors: {
      modalLink: 'a[href*="#modal"]:not(.quick-buy_link)',
      drawerLink: 'a[href*="#drawer"]',
    },
  },
  focusTraps: {},
  init: function () {
    // Init open event listeners
    document.querySelectorAll(this.settings.selectors.modalLink).forEach((modalLink) => {
      modalLink.addEventListener('click', (event) => {
        event.preventDefault();
        const targetId = event.currentTarget.getAttribute('href').substring(1).split('?')[0];
        const slideIndex = event.currentTarget.getAttribute('href').substring(1).split('?slide=')[1];
        const scrollToId = event.currentTarget.getAttribute('href').substring(1).split('?scroll=')[1];
        this.showModalOrDrawer(targetId, parseInt(slideIndex), scrollToId);
      });
    });

    document.querySelectorAll(this.settings.selectors.drawerLink).forEach((drawerLink) => {
      drawerLink.addEventListener('click', (event) => {
        event.preventDefault();
        const targetId = event.currentTarget.getAttribute('href').substring(1).split('?')[0];
        this.showModalOrDrawer(targetId);
      });
    });

    // Init close event listeners
    const closeBtns = document.querySelectorAll('[data-close]');
    if (closeBtns) {
      closeBtns.forEach((closeBtn) => {
        closeBtn.addEventListener('click', this.closeModalOrDrawerOrDrawerFromEvent.bind(this));
      });
    }

    const overlays = document.querySelectorAll('[data-overlay]');
    if (overlays) {
      overlays.forEach((overlay) => {
        overlay.addEventListener('click', this.closeModalOrDrawerOrDrawerFromEvent.bind(this));
      });
    }

    // Escape to close all
    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' || event.keyCode === 27) {
        document.querySelectorAll('.drawer').forEach((drawer) => {
          drawer.classList.remove('is-open');
        });
        document.querySelectorAll('.modal').forEach((modal) => {
          modal.classList.remove('is-open');
        });
        
        // Simply re-enable scroll - no scroll restoration needed
        document.body.classList.remove('overflow-hidden');
      }
    });
  },
  /**
   *
   * @param {string} targetId - ID of modal or drawer element, e.g. modal-geo, drawer-menu
   * @param {int} slideIndex - Index of a Gridy Slider slide inside the opened modal - (sliding motion)
   * @param {string} scrollToId - ID of a Gridy Slider slide inside the opened modal - (no motion)
   * Traps focus to modal and disables body scrolling.
   */
  showModalOrDrawer: function (targetId, slideIndex, scrollToId) {
    const targetElement = document.getElementById(targetId);
    if (!targetElement && Woolman.Utils.debugMode) {
      console.warn('No modal/drawer element specified');
    }
    if (!targetElement) {
      return;
    }

    if (targetElement.classList.contains('is-open')) return;

    // If this is a drawer, set top/height BEFORE adding is-open class to ensure smooth animation
    if (targetElement.classList.contains('drawer')) {
      // Set --drawer-height based on current viewport (captures visible height at open time)
      const drawerHeight = window.innerHeight;
      document.documentElement.style.setProperty('--drawer-height', `${drawerHeight}px`);

      const offset = Woolman.Utils.getAnnouncementOffset();
      const panels = targetElement.querySelectorAll('.drawer-panel, .drawer-submenu__panel');
      const overlays = targetElement.querySelectorAll('[data-overlay], .page-overlay');
      
      // Check if mobile (same breakpoint as drawer-menu.js)
      const isMobile = window.innerWidth < 992;

      const applyOffsetStyles = (node) => {
        if (offset > 0) {
          node.style.top = `${offset}px`;
          // Use var(--drawer-height) for mobile, vh for desktop
          if (isMobile) {
            const heightValue = `calc(var(--drawer-height, 100svh) - ${offset}px)`;
            node.style.height = heightValue;
            node.style.maxHeight = heightValue; // Ensure it doesn't exceed
          } else {
            const heightValue = `calc(100vh - ${offset}px)`;
            node.style.height = heightValue;
            node.style.maxHeight = heightValue;
          }
        } else {
          node.style.removeProperty('top');
          // On mobile without offset, let CSS handle it (uses var(--drawer-height))
          if (!isMobile) {
            node.style.removeProperty('height');
            node.style.removeProperty('max-height');
          } else {
            // Mobile: remove inline styles to let CSS use var(--drawer-height)
            node.style.removeProperty('height');
            node.style.removeProperty('max-height');
          }
        }
      };

      // Overlays use inset:0 for full coverage - only adjust top if announcement bar exists
      const applyOverlayStyles = (node) => {
        if (offset > 0) {
          // Overlay should start below announcement bar but still cover full viewport
          node.style.top = `${offset}px`;
          node.style.bottom = '0';
          node.style.removeProperty('height'); // Let inset handle height
        } else {
          node.style.removeProperty('top');
          node.style.removeProperty('bottom');
          node.style.removeProperty('height');
        }
      };

      // Also set top/height on the drawer container itself (like drawer-menu.js does)
      if (offset > 0) {
        targetElement.style.top = `${offset}px`;
        if (isMobile) {
          const heightValue = `calc(var(--drawer-height, 100svh) - ${offset}px)`;
          targetElement.style.height = heightValue;
          targetElement.style.maxHeight = heightValue;
        } else {
          const heightValue = `calc(100vh - ${offset}px)`;
          targetElement.style.height = heightValue;
          targetElement.style.maxHeight = heightValue;
        }
      } else {
        targetElement.style.removeProperty('top');
        if (isMobile) {
          // Mobile: remove inline styles to let CSS use var(--drawer-height)
          targetElement.style.removeProperty('height');
          targetElement.style.removeProperty('max-height');
        } else {
          targetElement.style.removeProperty('height');
          targetElement.style.removeProperty('max-height');
        }
      }

      // Set styles before animation starts
      panels.forEach(applyOffsetStyles);
      overlays.forEach(applyOverlayStyles);
      
      // Force a reflow to ensure styles are applied before adding is-open class
      targetElement.offsetHeight;
    }

    targetElement.classList.add('initialized', 'is-open');
    
    // Simply disable scroll - no position:fixed needed
    document.body.classList.add('overflow-hidden');

    setTimeout(() => {
      trapFocus(targetElement);

      // Focus on drawerSearchInput if it exists
      const drawerSearchInput = targetElement.querySelector('#drawerSearchInput');
      if (drawerSearchInput) {
        drawerSearchInput.focus();
      }
    }, 600);

    if (slideIndex) {
      setTimeout(() => {
        const gridySlider = targetElement.querySelector('gridy-slider');
        gridySlider.scrollToSlide(slideIndex - 1);
      }, 600);
    } else if (scrollToId) {
      const scrollToElement = document.getElementById(scrollToId),
            modal_dialog = targetElement.querySelector('.gridy-track');

      modal_dialog.scrollTo({
        top: scrollToElement.offsetTop,
        left: scrollToElement.offsetLeft,
        behavior: "instant"
      });
    }
  },
  closeModalOrDrawer: function(targetId) {
    const targetElement = document.getElementById(targetId);
    targetElement.classList.remove('is-open');
    
    // Remove position:fixed - do NOT restore scroll position
    document.body.classList.remove('overflow-hidden');
    document.body.style.top = '';
    
    // For cart drawer, hide after transition completes to allow proper reopening
    if (targetId === 'drawer-cart' && targetElement.classList.contains('initialized')) {
      const panel = targetElement.querySelector('.drawer-panel');
      if (panel) {
        panel.addEventListener('transitionend', function hideAfterTransition() {
          targetElement.style.display = 'none';
          targetElement.style.visibility = 'hidden';
          panel.removeEventListener('transitionend', hideAfterTransition);
        }, { once: true });
      }
    }
  },
  closeModalOrDrawerOrDrawerFromEvent: function (event) {
    event.preventDefault();
    removeTrapFocus();
    const parentElement = event.currentTarget.closest('[data-parent]');
    parentElement.classList.remove('is-open');
    
    // Simply re-enable scroll - no scroll restoration needed
    document.body.classList.remove('overflow-hidden');
  }
};

/**
 * Allow us to trigger something when window is actually resized.
 */
let woolman_window_size = window.innerWidth;
window.addEventListener(
  'resize',
  debounce(() => {
    if (window.innerWidth == woolman_window_size) {
      return;
    }
    woolman_window_size = window.innerWidth;
    document.dispatchEvent(new CustomEvent('woolman:resize'));
  }),
  250
);

/**
 * Animated details element
 */
class Accordion {
  constructor(el) {
    this.el = el;
    this.summary = el.querySelector('summary');
    this.content = el.querySelector('.content');

    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.summary.addEventListener('click', (e) => this.onClick(e));
    this.toggleByViewport();
    document.addEventListener('woolman:resize', this.toggleByViewport.bind(this));
  }

  onClick(e) {
    e.preventDefault();
    this.el.style.overflow = 'hidden';
    if (this.isClosing || !this.el.open) {
      this.open();
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }

  shrink() {
    this.isClosing = true;

    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.el.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 400,
      easing: 'ease-in-out'
    });

    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => this.isClosing = false;
  }

  open() {
    this.el.style.height = `${this.el.offsetHeight}px`;
    this.el.open = true;
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    this.isExpanding = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.el.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 400,
      easing: 'ease-out'
    });
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => this.isExpanding = false;
  }

  onAnimationFinish(open) {
    this.el.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.style.height = this.el.style.overflow = '';
  }

  toggleByViewport() {
    let mobileClose = this.el.dataset.mobileClose != undefined ? JSON.parse(this.el.dataset.mobileClose) : false;
    let desktopOpen = this.el.dataset.desktopOpen != undefined ? JSON.parse(this.el.dataset.desktopOpen) : false;

    if (woolman_window_size >= 768 && desktopOpen) {
      this.el.open = true;
    } else if (mobileClose) {
      this.el.open = false;
    }
  }
};

Woolman.DetailsAccordions = {
  init: function () {
    document.querySelectorAll('details').forEach((el) => {
      new Accordion(el);
    });
  }
};

Woolman.init();

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="locale_code"], input[name="country_code"]')
    };

    this.querySelectorAll('a[data-value]').forEach((item) => {
      item.addEventListener('click', this.onItemClick.bind(this));
    });
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    if (!form || !this.elements.input) return;

    this.elements.input.value = event.currentTarget.dataset.value;

    const returnToInput = form.querySelector('[name="return_to"]');
    if (returnToInput) {
      let returnTo = window.location.pathname + window.location.search;
      if (!returnTo || returnTo.indexOf('/localization') === 0) {
        returnTo = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      }
      // Strip params that fight localization redirects on local/preview
      try {
        const url = new URL(returnTo, window.location.origin);
        url.searchParams.delete('country');
        url.searchParams.delete('currency');
        url.searchParams.delete('language_code');
        url.searchParams.delete('locale_code');
        returnTo = url.pathname + url.search;
      } catch (e) {
        // keep returnTo as-is
      }
      const filterIndex = returnTo.indexOf('?filter');
      if (filterIndex !== -1) {
        const before = returnTo.substring(0, filterIndex);
        const after = returnTo.substring(filterIndex).replace(/%2C/g, ',');
        returnTo = before + after;
      }
      returnToInput.value = returnTo;
    }

    form.submit();
  }
}

customElements.define('localization-form', LocalizationForm);

// Custom element that enhances HTML Video Element functionality.
// Usage: <video is="superpowered-video">
class SuperPoweredVideo extends HTMLElement {
  constructor() {
    super();

    this.video = this.querySelector('video') || this.querySelector('iframe');
    this.container = this.closest('.video-container') || null;

    if (this.container) this.attachClickListener(this.closest('.video-container'));

    // check if video is iframe and has a src and that src is youtube
    if (this.video.nodeName === 'IFRAME' && this.video.src && this.video.src.includes('youtube') && !this.container) {
      this.video.addEventListener('load', this.onVideoLoad.bind(this));
    }

    // When video is out of viewport pause it. This is to prevent videos from playing in the background.
    // If video is in viewport play it.
    // Use: Intersection Observer API
    const autoplay = this.dataset.autoplay || false;
    if (!autoplay || this.container) return;

    const videoType = this.video.nodeName === 'VIDEO' ? 'video' : 'iframe';
    const videoHost = this.video.nodeName === 'VIDEO' ? 'shopify' : (this.video.src.includes('youtube') ? 'youtube' : 'vimeo');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (videoType == 'video') {
            this.video.play();
          } else if (videoHost == 'youtube') {
            this.video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
          } else if (videoHost == 'vimeo') {
            this.video.contentWindow.postMessage('{"method":"play"}', '*');
          }
        } else {
          if (videoType == 'video') {
            this.video.pause()
          } else if (videoHost == 'youtube') {
            this.video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          } else if (videoHost == 'vimeo') {
            this.video.contentWindow.postMessage('{"method":"pause"}', '*');
          }
        }
      });
    } , { threshold: 0.5 });

    observer.observe(this.video);
  }

  attachClickListener(videoContainer) {
    if (!videoContainer) return;
    videoContainer.addEventListener('click', (e) => {
      if (this.video.paused) {
        this.video.play();
      } else {
        this.video.pause();
      }
    });

    this.video.onplay = () => {
      videoContainer.querySelector('button').hidden = true;
    }

    this.video.onpause = () => {
      videoContainer.querySelector('button').hidden = false;
    }
  }

  onVideoLoad() {
    // force youtube to play on mobile
    this.video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
  }
}
customElements.define('superpowered-video', SuperPoweredVideo);

// Gridy Slider - a custom Woolman built slider.
// Usage: <gridy-slider>
class GridySlider extends HTMLElement {
  constructor() {
    super();

    this.track = this.querySelector(':scope > .gridy-track');
    this.slides = this.track ? this.track.children : [];
    const child_count = this.track ? this.track.childElementCount : 0;

    const data_ipr_desktop = parseInt(this.dataset.iprDesktop, 10) || 1;
    const data_ipr_tablet = parseInt(this.dataset.iprTablet, 10) || data_ipr_desktop;
    const data_ipr_mobile = parseInt(this.dataset.iprMobile, 10) || 1;
    const data_init_scroll_to = this.dataset.initScrollTo;
    const data_autoplay = this.dataset.autoplay != undefined ? JSON.parse(this.dataset.autoplay) : false;
    const data_autoplay_delay = parseInt(this.dataset.autoplayDelay, 10) || 5000;
    const data_is_thumbnails_slider = this.dataset.thumbnailsFor != undefined ? true : false;
    const data_indicator = this.dataset.indicator != undefined ? JSON.parse(this.dataset.indicator) : false;
    const data_sliding_behavior = this.dataset.slidingBehavior;
    const data_thumbnail_slider = document.getElementById(`thumbnail-${this.id}`);
    const data_track_overflow_visible = this.dataset.overflowVisible != undefined ? true : false;
    const data_loop = this.dataset.loop !== 'false';

    this.config = {
      slide_count: child_count,
      current_slide: 0,
      active_slide_offset: 0, // used for thubnails slider

      ipr_desktop: data_ipr_desktop,
      ipr_tablet: data_ipr_tablet,
      ipr_mobile: data_ipr_mobile,
      breakpoint_tablet: 768,
      breakpoint_desktop: 1024,

      arrows: true,
      loop: data_loop,
      autoplay: data_autoplay || false,
      autoplay_delay: data_autoplay_delay, // in ms
      timer: null,

      // thumbnails related
      is_thumbnails_slider: data_is_thumbnails_slider,
      thumbnails_for: undefined,
      thumbnail_slider: data_thumbnail_slider,

      indicator: data_indicator,
      track_overflow_visible: data_track_overflow_visible,
      sliding_behavior: data_sliding_behavior || 'all'
    }

    // SCROLL ON INIT (with variant URL)
    if (data_init_scroll_to != undefined) {
      this.scrollToSlideByID(data_init_scroll_to);
    }

    // ARROWS INIT (direct children only — avoids nested card sliders inside section sliders)
    this.arrowsContainer = this.querySelector(':scope > .gridy-arrows');
    if (this.config.arrows) {
      this.buttons = this.arrowsContainer
        ? this.arrowsContainer.querySelectorAll('[data-gridy-arrow]')
        : this.querySelectorAll(':scope > [data-gridy-arrow]');
      this.buttons.forEach((arrowButton) => {
        arrowButton.addEventListener('click', this.onArrowClick.bind(this));
      });
    }

    // AUTOPLAY INIT
    if (this.config.autoplay) {
      this.autoplayGridy();

      // Always pause on hover
      this.addEventListener('mouseenter', this.clearAutoplayTimer);
      this.addEventListener('mouseleave', this.autoplayGridy);

      // Pause for touch devices
      this.addEventListener('touchenter', this.clearAutoplayTimer);
      this.addEventListener('touchleave', this.autoplayGridy);
    }

    // THUMBNAILS INIT
    if (this.config.is_thumbnails_slider) {
      this.config.active_slide_offset =  2,
      this.config.thumbnails_for = document.getElementById(this.dataset.thumbnailsFor);
      this.thumbnail = this.querySelectorAll('[data-thumbnail-btn]');
      this.thumbnail.forEach((thumbnail) => {
        thumbnail.addEventListener('click', this.onThumbnailClick.bind(this));
      });
    }

    // CURRENT SLIDE INDICATORS INIT
    if (this.config.indicator) {
      this.indicator_dots = this.querySelectorAll('[data-indicator-dot]');
      this.indicator_current = this.querySelector('[data-indicator-current]');
    }

    // SCROLL LISTENER (for setting active slide after normal scroll)
    if (this.track && !this.config.is_thumbnails_slider) {
      if (this.classList.contains('card-product-slider')) {
        this.initCardProductSliderScroll();
      } else {
        let scrollTimeout;
        this.track.addEventListener('scroll', function() {
          clearTimeout(scrollTimeout);
          scrollTimeout = setTimeout(this.afterScrollStops.bind(this), 200);
        }.bind(this));
      }
    }

    if (this.classList.contains('card-product-slider')) {
      this.initCardProductNestedSliderIsolation();
      this.initCardProductTrackClick();
      this.syncCardProductSliderState({ explicitIndex: 0 });
    }
  }

  initCardProductSliderScroll() {
    this._cardSliderSupportsScrollEnd = 'onscrollend' in this.track;
    this._cardSliderNav = {
      active: false,
      targetIndex: null,
      fallbackTimer: null,
    };
    this._cardSliderScrollFallback = null;

    this.track.addEventListener('scroll', () => {
      if (this._cardSliderNav.active) {
        // Arrow click: keep index locked to intended target until scroll settles
        this.syncCardProductSliderState({ explicitIndex: this._cardSliderNav.targetIndex });
        clearTimeout(this._cardSliderNav.fallbackTimer);
        this._cardSliderNav.fallbackTimer = setTimeout(() => {
          this.onCardSliderScrollSettled();
        }, 200);
        return;
      }

      // Swipe / trackpad: update live from scroll position (arrows + progress on desktop)
      if (this.isCardProductSliderMobile()) {
        this.syncCardProductProgressOnly();
      } else {
        this.syncCardProductSliderState();
      }

      // Debounced settle — primary for card sliders (scrollend is unreliable and can
      // fire early, cancelling this timer with a stale index)
      clearTimeout(this._cardSliderScrollFallback);
      this._cardSliderScrollFallback = setTimeout(() => {
        this.onCardSliderScrollSettled();
      }, 200);
    }, { passive: true });
  }

  isCardProductSliderMobile() {
    return woolman_window_size < this.config.breakpoint_tablet;
  }

  syncCardProductProgressOnly() {
    const index = this.getCardProductSlideIndex();
    const slideCount = this.slides.length || this.config.slide_count;
    this.config.current_slide = index;
    this.renderCardProductProgress(index, slideCount);
  }

  beginCardSliderArrowNav(targetIndex) {
    this._cardSliderNav.active = true;
    this._cardSliderNav.targetIndex = targetIndex;
    clearTimeout(this._cardSliderNav.fallbackTimer);
    clearTimeout(this._cardSliderScrollFallback);

    this._cardSliderNav.fallbackTimer = setTimeout(() => {
      this.onCardSliderScrollSettled();
    }, 350);

    this.syncCardProductSliderState({ explicitIndex: targetIndex });
  }

  releaseCardSliderNavigationLock() {
    this._cardSliderNav.active = false;
    this._cardSliderNav.targetIndex = null;
  }

  onCardSliderScrollSettled() {
    clearTimeout(this._cardSliderNav.fallbackTimer);
    this._cardSliderNav.fallbackTimer = null;

    this.releaseCardSliderNavigationLock();

    const index = this.getCardProductSlideIndex();
    this.config.current_slide = index;
    this.setActiveSlide(this.slides[index]);
    this.syncCardProductSliderState({ explicitIndex: index });
  }

  syncCardProductSliderState({ explicitIndex = null } = {}) {
    if (!this.classList.contains('card-product-slider')) {
      return;
    }

    let index = explicitIndex;
    if (index === null || index === undefined) {
      index = this.getCardProductSlideIndex();
    }

    const slideCount = this.slides.length || this.config.slide_count;
    index = Math.max(0, Math.min(index, slideCount - 1));
    this.config.current_slide = index;

    this.renderCardProductProgress(index, slideCount);

    if (!this.config.loop) {
      this.updateArrowVisibility();
    }
  }

  renderCardProductProgress(index, slideCount) {
    const progress = this.querySelector(':scope > .card-product-slider__overlay [data-card-slider-progress]');
    const thumb = progress?.querySelector('[data-card-slider-thumb]');

    if (!progress || !thumb) {
      return;
    }

    if (slideCount <= 1) {
      progress.hidden = true;
      return;
    }

    progress.hidden = false;

    const trackWidth = progress.offsetWidth || 20;
    const thumbWidth = trackWidth * 0.5;
    const maxLeft = trackWidth - thumbWidth;
    const left = slideCount > 1 ? (index * maxLeft) / (slideCount - 1) : 0;

    thumb.style.width = `${thumbWidth}px`;
    thumb.style.left = `${left}px`;
    progress.setAttribute('aria-valuenow', index + 1);
    progress.setAttribute('aria-valuemax', slideCount);
  }

  initCardProductNestedSliderIsolation() {
    if (!this.track) {
      return;
    }

    const stopPropagation = (event) => event.stopPropagation();
    this.track.addEventListener('pointerdown', stopPropagation);
    this.track.addEventListener('touchstart', stopPropagation, { passive: true });
    this.track.addEventListener('wheel', stopPropagation, { passive: true });
  }

  connectedCallback() {
    if (this.classList.contains('card-product-slider') && this.track) {
      this.track.scrollLeft = 0;
      this.syncCardProductSliderState({ explicitIndex: 0 });
      return;
    }

    if (!this.config || this.config.loop) {
      return;
    }

    if (this.track) {
      this.updateArrowVisibility();
    }
  }

  afterScrollStops() {
    let slideInView = this.firstSlideInView();
    this.config.current_slide = slideInView;
    this.setActiveSlide(this.slides[slideInView + this.config.active_slide_offset]);

    // SYNC BACK TO THUMBNAILS SLIDER
    if (this.config.thumbnail_slider) {
      this.config.thumbnail_slider.scrollToSlide(slideInView);
    }

    if (!this.config.loop) {
      this.updateArrowVisibility();
    }
  }

  getCardProductSlideIndex() {
    if (!this.track || !this.slides.length) {
      return this.config.current_slide;
    }

    const slideCount = this.slides.length;
    if (slideCount <= 1) {
      return 0;
    }

    const maxScroll = this.track.scrollWidth - this.track.clientWidth;
    if (maxScroll > 0 && this.track.scrollLeft >= maxScroll - 1) {
      return slideCount - 1;
    }

    const slideWidth = this.slides[0].offsetWidth;
    if (slideWidth > 0) {
      return Math.min(
        slideCount - 1,
        Math.max(0, Math.round(this.track.scrollLeft / slideWidth))
      );
    }

    const trackCenter = this.track.scrollLeft + this.track.clientWidth / 2;
    let closestIndex = 0;
    let closestDistance = Infinity;

    Array.from(this.slides).forEach((slide, index) => {
      const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
      const distance = Math.abs(trackCenter - slideCenter);

      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    return closestIndex;
  }

  updateArrowVisibility() {
    if (!this.config || this.config.loop) {
      return;
    }

    const lastIndex = this.classList.contains('card-product-slider')
      ? Math.max(0, this.slides.length - 1)
      : Math.max(0, this.config.slide_count - this.getCurrentIPR());
    const arrowsContainer = this.arrowsContainer || this.querySelector(':scope > .gridy-arrows');
    const prevBtn = arrowsContainer?.querySelector('[data-direction="prev"]');
    const nextBtn = arrowsContainer?.querySelector('[data-direction="next"]');

    if (!prevBtn && !nextBtn) {
      return;
    }

    const atStart = this.config.current_slide <= 0;
    const atEnd = this.config.current_slide >= lastIndex;

    if (prevBtn) {
      prevBtn.hidden = atStart;
      prevBtn.disabled = atStart;
      prevBtn.classList.toggle('is-hidden', atStart);
      prevBtn.setAttribute('aria-hidden', atStart);
    }
    if (nextBtn) {
      nextBtn.hidden = atEnd;
      nextBtn.disabled = atEnd;
      nextBtn.classList.toggle('is-hidden', atEnd);
      nextBtn.setAttribute('aria-hidden', atEnd);
    }
  }

  initCardProductTrackClick() {
    this._cardProductPointer = { x: 0, y: 0, moved: false };

    this.track.addEventListener('pointerdown', (event) => {
      this._cardProductPointer = { x: event.clientX, y: event.clientY, moved: false };
    });

    this.track.addEventListener('pointermove', (event) => {
      if (
        Math.abs(event.clientX - this._cardProductPointer.x) > 10 ||
        Math.abs(event.clientY - this._cardProductPointer.y) > 10
      ) {
        this._cardProductPointer.moved = true;
      }
    });

    this.track.addEventListener('click', (event) => {
      if (event.target.closest('[data-gridy-arrow]') || this._cardProductPointer.moved) {
        return;
      }

      const productUrl = this.closest('.card-media')?.querySelector('.card-media__link')?.href;
      if (productUrl) {
        window.location.href = productUrl;
      }
    });
  }

  autoplayGridy() {
    this.config.timer = setInterval(this.scrollByIPR.bind(this), this.config.autoplay_delay, 'next');
  }

  clearAutoplayTimer() {
    clearInterval(this.config.timer);
    this.config.timer = null;
  }

  onThumbnailClick(event) {
    event.preventDefault();
    this.config.current_slide = Array.from(event.currentTarget.parentNode.children).indexOf(event.currentTarget);
    this.config.thumbnails_for.scrollToSlideByID(event.currentTarget.dataset.itemId);
    this.scrollToSlide(this.config.current_slide);
  }

  onArrowClick(event) {
    event.stopPropagation();
    event.preventDefault();
    this.scrollByIPR(event.currentTarget.dataset.direction);
  }

  scrollByIPR(direction) {
    let currentIPR = this.getCurrentIPR(),
        slideMultiplier = this.config.sliding_behavior == 'all' ? currentIPR : 1,
        newCurrentSlide = this.config.current_slide,
        lastToShow = this.classList.contains('card-product-slider')
          ? this.slides.length - 1
          : this.config.slide_count - currentIPR;

    if (direction === 'next') {
      if (!this.config.loop && this.config.current_slide >= lastToShow) {
        return;
      }

      newCurrentSlide = newCurrentSlide + slideMultiplier;

      if (!this.config.loop) {
        newCurrentSlide = Math.min(newCurrentSlide, lastToShow);
      } else if (this.config.current_slide >= lastToShow) {
        newCurrentSlide = 0; // Loop to start if all shown
      }
    } else if (direction === 'prev') {
      if (!this.config.loop && this.config.current_slide <= 0) {
        return;
      }

      newCurrentSlide = newCurrentSlide - slideMultiplier;

      if (!this.config.loop) {
        newCurrentSlide = Math.max(newCurrentSlide, 0);
      } else if (this.config.current_slide > 0 && newCurrentSlide < 0) {
        newCurrentSlide = 0; // Must scroll to first item if before looping to the end
      } else if (newCurrentSlide < 0) {
        newCurrentSlide = lastToShow; // Loop to end slide past the first item
      }
    }

    this.config.current_slide = newCurrentSlide;

    if (this.classList.contains('card-product-slider')) {
      this.beginCardSliderArrowNav(newCurrentSlide);
    }

    this.scrollToSlide(newCurrentSlide);

    if (!this.classList.contains('card-product-slider') && !this.config.loop) {
      this.updateArrowVisibility();
    }
  }

  scrollToSlide(newPosition) {
    // Needs to use scrollTo() instead of scrollIntoView()
    // since the later affects window scroll and thus cannot
    // be used with autoplay sliders.

    if (isNaN(newPosition)) {
      return;
    }

    // Can show different active slide compared to scrollTo slide for example in thumbnails slider
    let slidePosWithOffset = newPosition - this.config.active_slide_offset,
        newScrollToSlidePos = slidePosWithOffset > 0 ? slidePosWithOffset : 0;

    const slideInNewScrollToPos = this.slides[newScrollToSlidePos];

    let scrollToLeft = slideInNewScrollToPos.offsetLeft,
        scrollToTop = slideInNewScrollToPos.offsetTop;

    // If the track overflow is visible the scroll offset much include the left padding of the track
    // That is calculated with the first child offsetLeft
    if (this.config.track_overflow_visible) {
      scrollToLeft = this.slides[newScrollToSlidePos].offsetLeft - this.slides[0].offsetLeft;
    }

    this.track.scrollTo({
      left: scrollToLeft,
      top: scrollToTop,
      behavior: "smooth",
    });

    Array.from(this.slides).forEach((item) => { item.classList.remove('active') });
    this.slides[newPosition].classList.add('active');

    if (this.classList.contains('card-product-slider')) {
      this.config.current_slide = newPosition;
      return;
    }

    if (!this.config.loop) {
      this.config.current_slide = newPosition;
      this.updateArrowVisibility();
    }
  }

  scrollToSlideByID(slideID) {
    // Second scrollTo method used with slideID
    // Used through thumbnails and variant change events

    const theSlide = document.getElementById(slideID),
          newPosition = Array.from(theSlide.parentNode.children).indexOf(theSlide);

    this.scrollToSlide(newPosition);
  }

  setActiveSlide(slide) {
    Array.from(this.slides).forEach((item) => { item.classList.remove('active') });
    slide.classList.add('active');

    if (this.config.indicator) {
      this.indicator_current.textContent = this.config.current_slide + 1;
      this.indicator_dots.forEach((dot) => { dot.classList.remove('active') });
      this.indicator_dots[this.config.current_slide].classList.add('active');
    }
  }

  // Utility, returns items per row value according to current viewport size
  getCurrentIPR() {
    let currentIPR = this.config.ipr_mobile;
    if (woolman_window_size >= this.config.breakpoint_desktop) {
      currentIPR = this.config.ipr_desktop;
    } else if (woolman_window_size >= this.config.breakpoint_tablet) {
      currentIPR = this.config.ipr_tablet;
    }
    return currentIPR;
  }

  // Utility, returns the position of the first slide in view (1..n)
  firstSlideInView() {
    let loopIndex = 0;
    for (const slide of this.slides) {
      if (this.isSlideInView(slide)) {
        return loopIndex;
      }
      ++loopIndex;
    }

    // If visibility check fails return the last known current_slide
    return this.config.current_slide;
  }

  // Element visibility check
  isSlideInView(slide) {
    const containerBounds = this.track.getBoundingClientRect();
    const slideBounds = slide.getBoundingClientRect();

    if (this.classList.contains('card-product-slider')) {
      const containerCenter = containerBounds.left + containerBounds.width / 2;
      const slideCenter = slideBounds.left + slideBounds.width / 2;
      return Math.abs(containerCenter - slideCenter) < slideBounds.width / 2;
    }

    const isSlideVisible =
    Math.round(slideBounds.top) >= Math.floor(containerBounds.top) &&
    Math.floor(slideBounds.bottom) <= Math.round(containerBounds.bottom) &&
    Math.round(slideBounds.left) >= Math.floor(containerBounds.left) &&
    Math.floor(slideBounds.right) <= Math.round(containerBounds.right);

    return isSlideVisible;
  }

}
customElements.define('gridy-slider', GridySlider);

// QuantityInput for + and - button functionality
// Used in: cart items, upsell items
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)));
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}
customElements.define('quantity-input', QuantityInput);

/*
 * Viewport Height Utility
 * Sets --vh and --svh CSS custom properties for browsers that don't support dvh/svh units
 * This fixes the issue where 100vh includes browser UI (address bar, etc.) on mobile
 */
(function() {
  // Check if browser supports viewport height units
  function supportsDvh() {
    try {
      return CSS.supports('height', '100dvh');
    } catch (e) {
      return false;
    }
  }

  function supportsSvh() {
    try {
      return CSS.supports('height', '100svh');
    } catch (e) {
      return false;
    }
  }

  let smallestViewportHeight = window.innerHeight;

  // Set the viewport height custom properties
  function setViewportHeight() {
    const currentHeight = window.innerHeight;
    
    // Track smallest viewport height for svh (smallest viewport height)
    if (currentHeight < smallestViewportHeight) {
      smallestViewportHeight = currentHeight;
    }

    // Only set if browser doesn't support the units
    if (!supportsDvh()) {
      const vh = currentHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    }

    if (!supportsSvh()) {
      const svh = smallestViewportHeight * 0.01;
      document.documentElement.style.setProperty('--svh', `${svh}px`);
    }
  }

  // Set initial value
  setViewportHeight();

  // Update on resize and orientation change
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(setViewportHeight, 100);
  });

  window.addEventListener('orientationchange', function() {
    // Reset smallest height on orientation change
    smallestViewportHeight = window.innerHeight;
    setTimeout(setViewportHeight, 100);
  });

  // Also update when the viewport might change (e.g., mobile browser UI showing/hiding)
  // Use visualViewport API if available (better for mobile browser UI changes)
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', setViewportHeight);
    window.visualViewport.addEventListener('scroll', setViewportHeight);
  }
})();

/**
 * Drawer Height Utility
 * Sets --drawer-height CSS custom property based on current window.innerHeight
 * This ensures drawers always cover the full visible viewport when opened,
 * preventing iOS browser bar "peeking" issues while avoiding layout jumps
 */
(function() {
  // Set drawer height based on current viewport
  function setDrawerHeight() {
    const drawerHeight = window.innerHeight;
    document.documentElement.style.setProperty('--drawer-height', `${drawerHeight}px`);
  }

  // Update on orientation change (drawer height should match new viewport)
  window.addEventListener('orientationchange', function() {
    setTimeout(setDrawerHeight, 100);
  });
})();